<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <div class="stockdata">
      <div class="item">
        <div class="info">
          <h3>库存总量/吨</h3>
          <p>{{data.stocknum}}吨</p>
        </div>
        <div class="ico ico1"></div>
      </div>
      <div class="item">
        <div class="info">
          <h3>总营业额</h3>
          <p>{{data.num}}元</p>
        </div>
        <div class="ico ico2"></div>
      </div>
      <div class="item">
        <div class="info">
          <h3>库存总量/升</h3>
          <p>{{data.lirun}}</p>
        </div>
        <div class="ico ico3"></div>
      </div>
      <div class="item">
        <div class="info">
          <div class="sels">
            <select @change="onsearch">
              <option value="1">当月利润</option>
              <option value="2">上月利润</option>
              <option value="3">本年利润</option>
            </select>
          </div>
          <p>{{lirun}}元</p>
        </div>
        <div class="ico ico4"></div>
      </div>
    </div>

    <RadioMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "加油站管理" },
        { name: "燃油销售" },
      ],
      menuIndex: '',
      menu: [
        {
          name: "每日订单",
          path: '/oilStation/fuelSales/day'
        },
        {
          name: "单车总量",
          path: '/oilStation/fuelSales/onecar'
        },
      ],
      data: {},
      lirun: 0,
    };
  },
  methods: {
    getData() {
      let url = `fuelsale/index`;
      const params = {}
      // console.log(url, params)
      this.post(url, params, (res) => {
        // console.log(res);
        this.data = res
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onsearch(e) {
      this.getLirun(e.target.value)
    },
    getLirun(index) {
      let url = `fuelsale/lirun`;
      const params = {
        index,
      }
      // console.log(url, params)
      this.post(url, params, ({ rilirun }) => {
        this.lirun = rilirun
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.menu.map(v => {
      if (this.$route.path.includes(v.path)) {
        this.menuIndex = v.path
      }
    })
    this.getData()
    this.getLirun(1)
  },
};
</script>

<style lang="less" scoped>
.stockdata {
  height: auto;
  overflow: hidden;
  margin: 0 auto 20px;
  font-family: "Microsoft Yahei";
  font-weight: 500;

  .item {
    float: left;
    position: relative;
    width: 23.5%;
    height: auto;
    overflow: hidden;
    margin: 0 2% 20px 0;
    border-radius: 5px;
    background: #fff;

    &:nth-child(4n) {
      margin: 0 0 20px 0;
    }

    .info {
      margin: 30px 80px 30px 30px;
      height: auto;
      overflow: hidden;

      h3 {
        height: 19px;
        line-height: 19px;
        overflow: hidden;
        margin: 0 auto 15px;
        font-size: 14px;
        color: #909399;
      }

      p {
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        margin: 0 auto;
        font-size: 30px;
        color: #303133;
      }

      .sels {
        height: 23px;
        line-height: 23px;
        overflow: hidden;
        margin: 0 auto 11px;

        select {
          font-size: 14px;
          color: #909399;
          border: none;
          border-radius: 5px;
          background: #F7F7F7;
        }
      }
    }

    .ico {
      position: absolute;
      right: 30px;
      top: 42px;
      width: 50px;
      height: 50px;

      &.ico1 {
        background: url(../../../assets/img/icon_stockdata_01.png) no-repeat center center;
        background-size: 50px;
      }

      &.ico2 {
        background: url(../../../assets/img/icon_stockdata_02.png) no-repeat center center;
        background-size: 50px;
      }

      &.ico3 {
        background: url(../../../assets/img/icon_stockdata_03.png) no-repeat center center;
        background-size: 50px;
      }

      &.ico4 {
        background: url(../../../assets/img/icon_stockdata_04.png) no-repeat center center;
        background-size: 50px;
      }
    }
  }
}
</style>
